export default "__VITE_PUBLIC_ASSET__53bb4a56__"